import { lazy } from "react";

import BlankLayout from "../layouts/blank-layout";
import IntroductionLayout from "../layouts/introduction.layout";
import WithBackBtnLayout from "../layouts/with-back-btn.layout";
import MainLayout from "../layouts/main.layout";

const Home = lazy(() => import("../views/home/home.view"));
const Introduction = lazy(() => import("../views/introduction/introduction.view"));
const Login = lazy(() => import("../views/authentication/login.view"));
const SelectCity = lazy(() => import("../views/authentication/select-city.view"));
const Membership = lazy(() => import("../views/authentication/membership.view"));

const CompleteProfile = lazy(() => import("../views/authentication/complete-profile.view"));
const ValidateOtp = lazy(() => import("../views/authentication/valiadte-otp.view"));

// const Club = lazy(() => import("../views/club/club.view"));

const CollectingRequestScore = lazy(() => import("../views/collecting-request-score/collecting-request-score.view"));

const FavoriteAddresses = lazy(() => import("../views/favorite-address/favorite-addresses.view"));
const FavoriteAddressNew = lazy(() => import("../views/favorite-address/add/favorite-address-new.view"));

const About = lazy(() => import("../views/about/about.view"));
// const Notifications = lazy(() => import("../views/notifications/notifications.view"));

const Withdraw = lazy(() => import("../views/withdraw/withdraw.view"));
const Elite = lazy(() => import("../views/elite/elite.view"));

const ShopCategories = lazy(() => import("../views/shop/shop-categories/shop-categories.view"));

const InviteFriends = lazy(() => import("../views/invite-friends/invite-friends.view"));

const Transactions = lazy(() => import("../views/transactions/transactions.view"));
const CollectsHistory = lazy(() => import("../views/collect-history/collect-history.view"));

const EditProfile = lazy(() => import("../views/edit-profile/edit-profile.view"));
// const DisabledDrivers = lazy(() =>
//     import("../views/disabled-driver/disabled-drivers.view")
// );

const Charities = lazy(() => import("../views/charity/charities.view"));
const CharityDetails = lazy(() => import("../views/charity/details/charity-details.view"));
const NewCollectionRequest = lazy(() => import("../views/new-collection-request/new-collection-request.view"));

const RubbishCategories = lazy(() => import("../views/rubbish-price/rubbish-categories.view"));
const RubbishDynamicPrice = lazy(() => import("../views/rubbish-price/rubbish-price-calculator.view"));

const Settings = lazy(() => import("../views/settings/settings.view"));
const NotFound = lazy(() => import("../views/not-found/not-found.view"));

const Headers = {
	dashboard: {
		title: "داشبورد",
		enTitle: "dashboard",
		order: 1,
	},
};

const AppRoutes = [
	{
		path: "/auth/login",
		exact: true,
		key: "login",
		component: Login,
		layout: IntroductionLayout,
		isPublic: true,
	},
	{
		path: "/",
		exact: false,
		key: "home",
		component: Home,
		hasBottomNavigation: true,
		layout: MainLayout,
	},

	{
		path: "/introduction",
		exact: true,
		key: "introduction",
		component: Introduction,
		layout: IntroductionLayout,
		isPublic: true,
	},
	{
		path: "/auth/select-city",
		exact: true,
		key: "selectCity",
		component: SelectCity,
		layout: IntroductionLayout,
		isPublic: true,
	},

	{
		path: "/auth/validate-otp",
		exact: true,
		key: "validateOtp",
		component: ValidateOtp,
		layout: IntroductionLayout,
		isPublic: true,
	},

	{
		path: "/auth/membership",
		exact: true,
		key: "membership",
		component: Membership,
		layout: IntroductionLayout,
		isPublic: true,
	},

	{
		path: "/collecting-request-score",
		exact: true,
		key: "collectingRequestScore",
		component: CollectingRequestScore,
		layout: BlankLayout,
	},

	{
		path: "/auth/complete-profile",
		exact: true,
		key: "completeProfile",
		component: CompleteProfile,
		layout: IntroductionLayout,
		isPublic: true,
	},
	// {
	// 	path: "/notifications",
	// 	exact: true,
	// 	key: "notifications",
	// 	component: Notifications,
	// 	layout: WithBackBtnLayout,
	// 	pageTitle: "اعلانات",
	// 	hasBottomNavigation: true,
	// },

	{
		path: "/withdraw",
		exact: true,
		key: "withdraw",
		component: Withdraw,
		layout: MainLayout,
		hasBottomNavigation: true,
	},
	{
		path: "/shop/elite",
		exact: true,
		key: "elite",
		component: Elite,
		layout: MainLayout,
		hasBottomNavigation: true,
	},
	{
		path: "/collects-history",
		exact: true,
		key: "collectsHistory",
		component: CollectsHistory,
		layout: WithBackBtnLayout,
		pageTitle: "سوابقِ جمع‌آوری پسماند",
		hasBottomNavigation: true,
	},

	{
		path: "/about",
		exact: true,
		key: "about",
		component: About,
		hasBottomNavigation: true,
		pageTitle: "دربارۀ اپلیکیشن کارو",
		layout: WithBackBtnLayout,
	},
	{
		path: "/invitation",
		exact: true,
		key: "inviteFriends",
		component: InviteFriends,
		hasBottomNavigation: false,
		pageTitle: "معرفی به دوستان",
		layout: WithBackBtnLayout,
	},

	{
		path: "/favorite-addresses",
		exact: true,
		key: "favoriteAddresses",
		component: FavoriteAddresses,
		hasBottomNavigation: true,
		pageTitle: "آدرس‌های منتخب",
		layout: WithBackBtnLayout,
	},

	{
		path: "/favorite-addresses/new",
		exact: true,
		key: "FavoriteAddressNew",
		component: FavoriteAddressNew,
		layout: BlankLayout,
	},

	{
		path: "/transactions",
		exact: true,
		key: "Transactions",
		component: Transactions,
		hasBottomNavigation: true,
		pageTitle: "تاریخچۀ تراکنش‌های مالی",
		layout: WithBackBtnLayout,
	},

	{
		path: "/edit-profile",
		exact: true,
		key: "EditProfile",
		component: EditProfile,
		pageTitle: "ویرایش حساب کاربری",
		layout: WithBackBtnLayout,
	},

	// {
	// 	path: "/club",
	// 	exact: true,
	// 	key: "club",
	// 	component: Club,
	// 	hasBottomNavigation: true,
	// 	layout: MainLayout,
	// },

	{
		path: "/new-collection-request",
		exact: true,
		key: "NewCollectionRequest",
		component: NewCollectionRequest,
		hasBottomNavigation: true,
		layout: BlankLayout,
	},

	{
		path: "/shop",
		exact: true,
		key: "shop",
		component: ShopCategories,
		hasBottomNavigation: true,
		layout: MainLayout,
	},

	{
		path: "/shop/charities",
		exact: true,
		key: "charities",
		component: Charities,
		hasBottomNavigation: true,
		layout: WithBackBtnLayout,
		pageTitle: "نیکوکاری",
	},

	{
		path: "/shop/charities/:id",
		exact: true,
		key: "charityDetails",
		component: CharityDetails,
		hasBottomNavigation: true,
		layout: BlankLayout,
	},

	{
		path: "/rubbishes-price",
		exact: true,
		key: "rubbishesPrice",
		component: RubbishCategories,
		hasBottomNavigation: false,
		layout: WithBackBtnLayout,
		pageTitle: "قیمت پسماندِ خشک",
	},
	{
		path: "/rubbish-dynamic-price/:rubbishId",
		exact: true,
		key: "rubbishesDynamicPriceCalculator",
		component: RubbishDynamicPrice,
		hasBottomNavigation: false,
		layout: BlankLayout,
	},

	{
		path: "settings",
		exact: true,
		key: "settings",
		component: Settings,
		hasBottomNavigation: false,
		layout: WithBackBtnLayout,
		pageTitle: "تنظیمات",
	},
	{
		path: "*",
		key: "notFound",
		component: NotFound,
		layout: BlankLayout,
		isPublic: true,
	},
];

export default {
	AppRoutes,
	Headers,
};
